<template>
  <v-app id="inspire">
    <v-content>
      <v-container class="pa-0">
        <v-card max-width="900" flat class="mx-auto pa-xs-0 pa-sm-10">
          <v-row aline="center" justify="center">
            <p class="title">利用者情報共有</p>
          </v-row>

          <v-row>
            <p v-if="admin()" class="px-3">
              管理者ユーザーのためすべての利用者情報が表示されます。
            </p>
            <p v-if="!admin()" class="ml-4">
              担当利用者様：
              <span v-for="ri in rijissekis" :key="ri.id"
                >{{ ri.rimyoji }}、</span
              >
              の情報が表示されます。
            </p>
          </v-row>

          <v-row align="center" justify="space-around" class="pa-1">
            <v-btn color="info" @click="nopen()">
              <v-icon>add</v-icon>新規追加
            </v-btn>
            <v-checkbox
              v-model="ka"
              color="success"
              label="確認済み"
              @change="searchlist()"
            />
            <v-checkbox v-model="mi" label="未確認" @change="searchlist()" />
            <v-col cols="12" md="6" style="background-color: white">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="検索キーワードを入力してください"
                single-line
                hide-details
                @input="searchlist()"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="6">
              <v-select
                v-model="sgyomu"
                :items="tags"
                item-text="text"
                item-value="id"
                label="検索区分"
                @change="searchlist()"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="6">
              <v-select
                v-model="sriid"
                :items="riyousyas"
                :item-text="(r) => r.rimyoji + r.riname"
                item-value="id"
                label="検索利用者"
                @change="searchlist()"
              ></v-select>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-list two-line width="100%">
              <v-list-item-group>
                <template v-for="item in ditems">
                  <v-list-item :key="item.id" class="listitem" inactive>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-chip
                          class="ma-2"
                          color="red"
                          text-color="white"
                          small
                          v-if="item.gyomu === 1"
                        >
                          事故・ヒヤリ
                        </v-chip>
                        <v-chip
                          class="ma-2"
                          color="success"
                          text-color="white"
                          small
                          v-if="item.gyomu === 2"
                        >
                          連絡
                        </v-chip>
                        <v-chip
                          class="ma-2"
                          color="primary"
                          text-color="white"
                          small
                          v-if="item.gyomu === 3"
                        >
                          報告
                        </v-chip>
                        <v-icon small>query_builder</v-icon>
                        {{ formatDate(item.jdate) }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="subtitle-1 black--text">
                        <v-icon small>person</v-icon>
                        {{ item.riname }} 登録者：{{ item.staffname }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle class="subtitle-1 black--text text">
                        <p
                          style="
                            white-space: pre-wrap;
                            word-wrap: break-word;
                            color: black;
                          "
                        >
                          <v-icon small>text_snippet</v-icon> {{ item.text }}
                        </p>
                      </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-btn color="primary" @click="editItem(item)">
                        <v-icon dark left>pageview</v-icon>詳細
                      </v-btn>

                      <!-- <v-btn
                        v-if="item.logid"
                        color="success"
                        @click="editItem(item)"
                      >
                        <v-icon dark left>check</v-icon>確認済み
                      </v-btn> -->

                      <v-btn-toggle dense v-if="admin()">
                        <v-btn small @click="reeditItem(item)">
                          <v-icon>edit</v-icon>編集
                        </v-btn>

                        <v-btn small @click="redelItem(item)">
                          <v-icon>delete</v-icon>削除
                        </v-btn>
                      </v-btn-toggle>
                    </v-list-item-action>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </v-list>

            <v-dialog v-model="dialog" fullscreen>
              <v-toolbar dense dark>
                <v-toolbar-title>利用者情報共有画面</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn @click="dialog = false">
                  <v-icon>close</v-icon>閉じる
                </v-btn>
              </v-toolbar>

              <v-card>
                <v-card-text class="pa-2">
                  <v-container>
                    <v-row dense>
                      <v-col cols="12" xs="12" sm="12" md="12">
                        <v-text-field
                          v-model="editedItem.created"
                          dense
                          disabled
                          label="登録日時"
                          class="black--text"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" xs="12" sm="6" md="6">
                        <v-text-field
                          v-model="editedItem.riname"
                          dense
                          disabled
                          label="利用者名"
                          class="black--text"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" xs="12" sm="6" md="6">
                        <v-text-field
                          v-model="editedItem.staffname"
                          dense
                          disabled
                          label="登録者"
                          class="black--text"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" xs="12" sm="4" md="4">
                        <v-text-field
                          v-model="editedItem.jdate"
                          dense
                          disabled
                          label="支援日"
                          class="black--text"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" xs="12" sm="4" md="4">
                        <v-text-field
                          v-model="editedItem.jkaisi"
                          dense
                          disabled
                          label="開始時間"
                          class="black--text"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" xs="12" sm="4" md="4">
                        <v-text-field
                          v-model="editedItem.jsyuryo"
                          dense
                          disabled
                          label="終了時間"
                          class="black--text"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" xs="12" sm="12" md="12">
                        <p>
                          <v-chip
                            class="ma-2"
                            color="red"
                            text-color="white"
                            small
                            v-if="editedItem.gyomu === 1"
                          >
                            事故・ヒヤリ
                          </v-chip>
                          <v-chip
                            class="ma-2"
                            color="primary"
                            text-color="white"
                            small
                            v-if="editedItem.gyomu === 2"
                          >
                            看護
                          </v-chip>
                          <v-chip
                            class="ma-2"
                            color="primary"
                            text-color="white"
                            small
                            v-if="editedItem.gyomu === 3"
                          >
                            連絡
                          </v-chip>
                          <v-chip
                            class="ma-2"
                            color="success"
                            text-color="white"
                            small
                            v-if="editedItem.gyomu === 4"
                          >
                            ケア変更
                          </v-chip>
                          <v-chip
                            class="ma-2"
                            color="success"
                            text-color="white"
                            small
                            v-if="editedItem.gyomu === 5"
                          >
                            報告
                          </v-chip>
                        </p>
                        <p
                          style="
                            color: black;
                            white-space: pre-wrap;
                            word-wrap: break-word;
                          "
                        >
                          {{ editedItem.text }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-container>

                  <!-- <p class="pa-3 pt-0 ma-0">確認リスト</p>
                  <ul class="mx-4">
                    <li
                      v-for="v in logs"
                      :key="v.id"
                      class="mb-0"
                      style="font-size: 100%; color: black"
                    >
                      {{ formatDate(v.created) }}
                      {{ v.staffname }} 確認済み
                    </li>
                  </ul> -->
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <!-- <v-btn
                    v-if="!editedItem.logid"
                    color="success"
                    @click="uplog()"
                  >
                    <v-icon>check</v-icon>確認しました
                  </v-btn> -->
                  <v-btn color @click="dialog = false">
                    <v-icon>close</v-icon>閉じる
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="ndialog" fullscreen>
              <v-toolbar dense dark>
                <v-toolbar-title>利用者情報共有追加画面</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn @click="ndialog = false">
                  <v-icon>close</v-icon>閉じる
                </v-btn>
              </v-toolbar>

              <v-card>
                <v-card-text class="pa-2">
                  <v-container>
                    <v-row dense>
                      <v-col cols="12" xs="12" sm="6" md="6">
                        <v-select
                          v-model="editedItem.gyomu"
                          :items="tags"
                          item-text="text"
                          item-value="id"
                          label="区分"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" xs="12" sm="6" md="6">
                        <v-select
                          v-model="editedItem.riid"
                          :items="riyousyas"
                          :item-text="(r) => r.rimyoji + r.riname"
                          item-value="id"
                          label="利用者"
                        ></v-select>
                      </v-col>

                      <v-col cols="12" xs="12" sm="12" md="12">
                        <v-textarea
                          v-model="editedItem.text"
                          solo
                          label="本文"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    v-if="!editedItem.logid"
                    color="success"
                    @click="addriinfo()"
                    >保存</v-btn
                  >
                  <v-btn color @click="ndialog = false">
                    <v-icon>close</v-icon>閉じる
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-pagination
              v-model="page"
              :length="pagelength"
              @input="pageChange"
            />

            <v-snackbar v-model="snackbar" color="info" :timeout="1000">{{
              msg
            }}</v-snackbar>
          </v-row>
        </v-card>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Common from "@/components/Common";
import Auth from "@/components/Auth";
import moment from "moment";
export default {
  filters: {
    truncate: function(value) {
      var length = 40;
      var ommision = "...";
      if (value.length <= length) {
        return value;
      }
      return value.substring(0, length) + ommision;
    }
  },
  mixins: [Common, Auth],
  data: () => ({
    page: 1,
    pagelength: 5,
    pagesize: 20,
    ka: true,
    mi: true,
    dialog: false,
    ndialog: false,
    items: [],
    ditems: [],
    witems: [],
    menu: false,
    search: "",
    riyousyas: [],
    rijissekis: [],
    editedIndex: -1,
    editedItem: {
      riname: "",
      hyoji: 0
    },
    logs: [],
    defaultItem: {
      riname: "",
      hyoji: 0
    },
    calday: moment().date(1),
    caldata: [],
    msg: "",
    snackbar: "",
    services: [],
    tag: 0,
    tags: [
      { id: 0, text: "全て" },
      { id: 1, text: "事故・ヒヤリ" },
      { id: 2, text: "連絡" },
      { id: 3, text: "報告" }
    ],
    sgyomu: 0,
    sriid: 0
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "新規追加" : "編集";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.kousin();
  },

  mounted() {
    this.getServices();
    this.getRiyousyas();
    this.getRiyousyaJisseki();
  },

  methods: {
    searchlist: function() {
      this.witems = [];
      let self = this;
      this.items.forEach(function(item) {
        let text = item.created + item.riname + item.text + item.staffname;
        if (
          text.indexOf(self.search) != -1 &&
          (self.sgyomu === 0 || self.sgyomu === item.gyomu) &&
          (self.sriid === 0 || self.sriid === item.riid)
        ) {
          self.witems.push(item);
        }
      });
      let sitems = [];
      this.witems.forEach(function(item) {
        if (self.ka && item.logid) {
          sitems.push(item);
        } else if (self.mi && !item.logid) {
          sitems.push(item);
        }
      });
      this.witems = sitems;
      this.pagelength = Math.round(this.witems.length / this.pagesize);
      this.pageChange(1);
    },
    pageChange: function(pagenum) {
      this.ditems = this.witems.slice(
        this.pagesize * (pagenum - 1),
        this.pagesize * pagenum
      );
    },
    getRiyousyaJisseki() {
      let self = this;
      this.$axios
        .post(
          this.url + "getRiyousyaJisseki.php",
          JSON.stringify({
            id: this.$store.getters.auth.id,
            role: this.$store.getters.auth.role
          })
        )
        .then(function(res) {
          self.rijissekis = res.data;
        });
    },
    getRiyousyas() {
      this.$axios.get(this.url + "getRiyousyas.php").then(response => {
        this.riyousyas = response.data;
        this.riyousyas.unshift({ id: 0, rimyoji: "全て", riname: "" });
      });
    },
    filter(value, search, item) {
      var text =
        item.date + item.riname + item.kaisi + item.syuryo + item.staffname;
      if (text.indexOf(search) != -1) return item;
    },
    formatDate: function(date) {
      if (date == "" || date == null) return "";
      return moment(date).format("MM/DD (ddd)");
    },
    moveLastMonth: function() {
      this.keyid = 0;
      this.calday.add(-1, "months");
      this.jkousin();
    },
    moveNextMonth: function() {
      this.keyid = 0;
      this.calday.add(1, "months");
      this.jkousin();
    },
    getServices() {
      this.$axios.get(this.url + "getServices.php").then(response => {
        this.services = response.data;
      });
    },
    kousin() {
      var self = this;
      this.$axios
        .post(
          this.url + "getRiinfo.php",
          JSON.stringify({
            kaisi: moment(this.calday).format("YYYY-MM-DD"),
            syuryo: moment(this.calday)
              .add(1, "months")
              .format("YYYY-MM-DD"),
            id: this.$store.getters.auth.id,
            role: this.$store.getters.auth.role,
            limit: ""
          })
        )
        .then(function(res) {
          self.items = res.data;
          self.ditems = self.items;
          self.pagelength = Math.round(self.items.length / self.pagesize);
          self.searchlist();
          self.pageChange(1);
        });
    },
    uplog() {
      var self = this;
      this.$axios
        .post(
          this.url + "updateLog.php",
          JSON.stringify({
            infoid: this.editedItem.id,
            id: this.$store.getters.auth.id,
            role: this.$store.getters.auth.role
          })
        )
        .then(function() {
          self.$set(self.editedItem, "logid", 1);
          self.dialog = false;
        });
    },
    addriinfo() {
      this.editedItem.sonota = this.editedItem.text;
      this.editedItem.staffid = this.$store.getters.auth.id;
      this.editedItem.date = moment().format("YYYY-MM-DD");
      var self = this;
      this.$axios
        .post(
          this.url + "updateRiinfo.php",
          JSON.stringify({
            item: this.editedItem
          })
        )
        .then(function() {
          self.msg = "登録完了しました。";
          self.snackbar = true;
          self.kousin();
          self.ndialog = false;
        });
    },
    editItem(item) {
      this.editedItem = item;
      this.dialog = true;
      this.logs = [];

      var self = this;
      this.$axios
        .post(
          this.url + "getRilogs.php",
          JSON.stringify({
            infoid: this.editedItem.id,
            id: this.$store.getters.auth.id,
            role: this.$store.getters.auth.role
          })
        )
        .then(function(res) {
          self.logs = res.data;
        });
    },
    redelItem(item) {
      this.editedItem = item;
      let result = window.confirm("削除してもよろしいですか？");
      if (result) {
        var self = this;
        this.$axios
          .post(
            this.url + "delRiinfo.php",
            JSON.stringify({
              item: this.editedItem,
              infoid: this.editedItem.id
            })
          )
          .then(function() {
            self.msg = "削除完了しました。";
            self.snackbar = true;
            self.kousin();
          });
      }
    },

    reeditItem(item) {
      this.editedItem = item;
      this.ndialog = true;
    },
    nopen() {
      this.ndialog = true;
      this.editedItem.date = "";
      this.editedItem.kaisi = "";
      this.editedItem.syuryuo = "";
      this.editedItem.sonota = "";
      this.editedItem.staffid = "";
      this.editedItem.date = "";
      this.editedItem.id = "";
      this.editedItem.riid = "";
      this.editedItem.gyomu = 0;
      this.editedItem.text = "";
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    }
  }
};
</script>

<style lang="stylus" scope>
.application {
}

.container {
  padding: 2;
}

:disabled {
  color: #000000 !important;
}

.listitem {
  border-top: 1px solid #dcdcdc;
}

.text {
  text-overflow: clip;
  white-space: normal;
}
</style>
